export class Constantes {
  static readonly URL_KERNEL_API: string = process.env.VUE_APP_KERNEL_API!;
  static readonly CLIENTE_DEBUGAR: string = 'demonstracaonovo.consultesaeweb.com.br';
  // static readonly CLIENTE_DEBUGAR: string =
  //   window.location.hostname === "localhost"
  //     ? "educacaocachoeirinha.consultesaeweb.com.br"
  //     : "demonstracaonovo.consultesaeweb.com.br";

  static readonly CONTRATO_CACHOEIRINHA: boolean =
    location.hostname === 'localhost' ||
    location.hostname.includes('educacaocachoeirinha') ||
    this.CLIENTE_DEBUGAR.includes('educacaocachoeirinha');

  /**
   * Ambiente de Prova de Conceito (contrato 9999, bancos ConsulteBase9999/SAEWEB9999).
   * O `CLIENTE_DEBUGAR` só conta em localhost: se alguém commitar o valor da POC nele, o build
   * de produção NÃO pode passar a tratar todo cliente como POC.
   */
  static readonly CONTRATO_POC: boolean =
    location.hostname.includes('poc.consultesaeweb') ||
    (location.hostname === 'localhost' && this.CLIENTE_DEBUGAR.includes('poc.consultesaeweb'));

  /**
   * Pré-matrícula por PROCESSO (tabelas Prm: inscrição → designação → matrícula). A flag é da
   * FUNCIONALIDADE, e não do contrato: quando outro contrato passar a usar, ele entra nesta
   * linha, sem caçar `CONTRATO_POC` pelo código. As tabelas só existem nos bancos onde os scripts
   * de `docs/pre-matricula/sql/tenant/` (repo da API acadêmica) rodaram.
   *
   * Vale para TODOS os contratos, menos Cachoeirinha (que tem a variante própria): a Central de
   * Vagas legada foi removida. NÃO é `!CONTRATO_CACHOEIRINHA`: ele é verdadeiro em qualquer
   * localhost, e o desenvolvimento local perderia a tela nova. Em localhost, quem decide é o
   * CLIENTE_DEBUGAR. Ver "Virada para todos os contratos" em `docs/pre-matricula/README.md` da API.
   */
  static readonly PREMATRICULA_POR_PROCESSO: boolean =
    !location.hostname.includes('educacaocachoeirinha') &&
    !(location.hostname === 'localhost' && this.CLIENTE_DEBUGAR.includes('educacaocachoeirinha'));

  static readonly FUNC_SIMULADOS_HABILITADA: boolean =
    location.hostname === 'localhost' ||
    this.CONTRATO_CACHOEIRINHA ||
    this.CLIENTE_DEBUGAR.includes('demonstracaonovo') ||
    this.CLIENTE_DEBUGAR.includes('homologacaonovo');

  static readonly REGENTE_LANCA_FALTAS_POR_PERIODO: boolean = this.CONTRATO_CACHOEIRINHA;
  static readonly LANCA_FALTAS_FLEXIVEIS: boolean = this.CONTRATO_CACHOEIRINHA;
  static readonly UTILIZA_BNCC_COM_RCG: boolean = this.CONTRATO_CACHOEIRINHA;
  static readonly FILTRO_LISTA_ESTUDANTES_CHAMADA_ORDEM_ALFABETICA: boolean = this.CONTRATO_CACHOEIRINHA;
  static readonly FILTRO_LISTA_ESTUDANTES_CHAMADA_APENAS_EFETIVOS: boolean = this.CONTRATO_CACHOEIRINHA;
  static readonly FILTRO_CHAMADA_EXIBIR_COLUNAS_PERCENTUAL_FALTAS: boolean = false;
  static readonly HEADERS_KERNEL_API =
    location.hostname === 'localhost' ||
      location.hostname.includes('saewebnew') ||
      location.hostname.includes('demonstracaonovo') ||
      location.hostname.includes('homologacaonovo')
      ? Constantes.CLIENTE_DEBUGAR
      : location.hostname;
}
